/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputFeedSummary
 */
export interface InputFeedSummary {
    /**
     * 
     * @type {string}
     * @memberof InputFeedSummary
     */
    feedRequestId: string;
    /**
     * 
     * @type {string}
     * @memberof InputFeedSummary
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof InputFeedSummary
     */
    userSummary: string;
    /**
     * 
     * @type {string}
     * @memberof InputFeedSummary
     */
    datacenterSummary: string;
    /**
     * 
     * @type {string}
     * @memberof InputFeedSummary
     */
    filtersSummary: string;
    /**
     * 
     * @type {string}
     * @memberof InputFeedSummary
     */
    adSummary: string;
}

/**
 * Check if a given object implements the InputFeedSummary interface.
 */
export function instanceOfInputFeedSummary(value: object): value is InputFeedSummary {
    if (!('feedRequestId' in value) || value['feedRequestId'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('userSummary' in value) || value['userSummary'] === undefined) return false;
    if (!('datacenterSummary' in value) || value['datacenterSummary'] === undefined) return false;
    if (!('filtersSummary' in value) || value['filtersSummary'] === undefined) return false;
    if (!('adSummary' in value) || value['adSummary'] === undefined) return false;
    return true;
}

export function InputFeedSummaryFromJSON(json: any): InputFeedSummary {
    return InputFeedSummaryFromJSONTyped(json, false);
}

export function InputFeedSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputFeedSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'feedRequestId': json['feed_request_id'],
        'userId': json['user_id'],
        'userSummary': json['user_summary'],
        'datacenterSummary': json['datacenter_summary'],
        'filtersSummary': json['filters_summary'],
        'adSummary': json['ad_summary'],
    };
}

export function InputFeedSummaryToJSON(json: any): InputFeedSummary {
    return InputFeedSummaryToJSONTyped(json, false);
}

export function InputFeedSummaryToJSONTyped(value?: InputFeedSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'feed_request_id': value['feedRequestId'],
        'user_id': value['userId'],
        'user_summary': value['userSummary'],
        'datacenter_summary': value['datacenterSummary'],
        'filters_summary': value['filtersSummary'],
        'ad_summary': value['adSummary'],
    };
}

